export default __webpack_public_path__ + "static/media/youtubeClone_2.b7c4a485.png";